<template>
  <b-modal size="md" v-model="isShow" hide-footer title="สแกนสินค้า" centered>
    <InputText
      id="input-scan-product"
      ref="input-scan-product"
      v-model="filter.search"
      type="text"
      faIcon="search"
      className="mb-2 bg-second "
      placeholder=""
      @onClickIcon="onSearch"
      textField="telephone"
      @onEnter="onSearch"
      @blur="focusInput"
      @input="convertValue"
    />
    <div class="panel-product background-panel" v-if="product.product_id == 0">
      {{ message }}
    </div>
    <div class="panel-product" v-else>
      <b-row class="align-items-center p-2" no-gutters>
        <!-- รูปภาพสินค้า -->
        <b-col cols="4" md="3">
          <b-img
            @error="handleImageSrc"
            :src="product.image_url || default_image"
            alt="Luxury Goods"
            fluid
          />
        </b-col>

        <!-- รายละเอียดสินค้า -->
        <b-col cols="8" md="9">
          <b-row class="px-3">
            <b-col cols="5" class="text-left">จำนวน:</b-col>
            <b-col cols="7" class="text-left">
              {{ product.quantity }}/{{ product.total }}</b-col
            >

            <b-col cols="5" class="text-left">ชื่อสินค้า:</b-col>
            <b-col cols="7" class="text-left">
              {{ product.product_name }}</b-col
            >

            <b-col cols="5" class="text-left">Barcode:</b-col>
            <b-col cols="7" class="text-left"> {{ product.barcode }}</b-col>
            <template v-if="product.serial_name">
              <b-col cols="5" class="text-left">Serial:</b-col>
              <b-col cols="7" class="text-left">
                {{ product.serial_name }}</b-col
              >
            </template>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div class="d-flex align-items-center w-100">
      <b-button @click="isShow = false">ปิด</b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isShow: false,
      stockList: [],
      selected: [],
      filter: {
        search: "",
      },
      message: "กรุณาสแกนบาร์โค้ด",
      product: {
        product_id: 0,
        image_url: null,
        product_name: "",
        is_product_serial: 0,
        serial_name: null,
        quantity: 1,
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  mounted() {
    // this.intervalId = setInterval(() => {
    //   if (document.activeElement !== this.$refs["input-scan-product"]) {
    //     this.$refs["input-scan-product"].focus();
    //   }
    // }, 100);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    convertThaiToEnglish(str, enable = true) {
      const THAI_TO_EN_MAP = {
        ๆ: "1",
        ไ: "2",
        ๅ: "3",
        พ: "4",
        ะ: "5",
        "ั": "6",
        า: "7",
        ส: "8",
        ด: "9",
        ถ: "0",
        ผ: "-",
        ฝ: "=",

        ฟ: "a",
        ห: "s",
        ก: "d",
        ด: "f",
        เ: "g",
        "้": "h",
        "่": "j",
        า: "k",
        ส: "l",
        ว: ";",
        ง: "'",
        จ: "z",
        ข: "x",
        ช: "c",
        ซ: "v",
        บ: "b",
        ล: "n",
        ฃ: "m",
        ฅ: ",",
      };

      return str
        .split("")
        .map((ch) => THAI_TO_EN_MAP[ch] || ch)
        .join("");
    },
    async show() {
      this.isShow = true;
      await this.$nextTick();

      setTimeout(() => {
        this.$refs["input-scan-product"].triggerFocus();
      }, 100);
      this.filter.search = "";
      this.product = {
        product_id: 0,
        image_url: null,
        product_name: "",
        is_product_serial: 0,
        serial_name: null,
        quantity: 1,
        total: 0,
      };
    },
    hide() {
      this.isShow = false;
      this.product = {
        product_id: 0,
        image_url: null,
        product_name: "",
        is_product_serial: 0,
        serial_name: null,
        quantity: 1,
        total: 0,
      };
    },

    submit() {
      this.$emit("submit", this.selected);
    },
    async onSearch() {
      const res = await this.axios.post(
        `${this.$baseUrl}/inventorycheck/scan-product`,
        {
          inventory_check_id: this.$route.params.id,
          barcode: this.filter.search,
        }
      );

      if (res.result) {
        this.product = res.detail;
        this.product.barcode = this.filter.search;
        this.$emit("fetch");
      } else {
        this.message = res.message;
      }
      this.filter.search = "";
    },
    convertValue(value) {
      console.log(value);
      // console.log(this.convertThaiToEnglish(value));
    },
    focusInput() {
      this.$refs["input-scan-product"].triggerFocus();
    },
    handleKeydown(e) {
      if (e.key === "Enter") {
        console.log("Barcode scanned:", this.filter.search);
        this.filter.search = "";
        return;
      }

      // เก็บตัวอักษรทีละตัวที่มาจากสแกน
      this.filter.search += e.key;

      // เคลียร์ filter.search ถ้านานเกิน 500ms
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //   this.filter.search = "";
      // }, 500);
    },
  },
};
</script>

<style>
.panel-product {
  text-align: center;

  min-height: 200px;
  align-content: center;
  margin: 10px 0;
}
.background-panel {
  background-color: rgb(204, 204, 204);
}
</style>
